import type { AllRouteEndpoints } from "../routeTypes";
export const postIntegrationsDirectCdiImportSyncsTestConnectionCacheKeys: AllRouteEndpoints[] = [];
